import React from "react";

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <div className="social">
            <a
              href="https://www.facebook.com/ShopeeSingapore/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="images/icon-facebook.png"
                className="icon"
                alt="facebook"
              ></img>
            </a>
            <a
              href="https://www.instagram.com/LifeatShopee"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="images/icon-instagram.png"
                className="icon"
                alt="facebook"
              ></img>
            </a>
            <a
              href="https://linkedin.com/company/shopee"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="images/icon-linkedin.png"
                className="icon"
                alt="facebook"
              ></img>
            </a>
          </div>
        </div>
        <div className="col-md-6">
          <div className="info">
            <a
              href="pdf/terms-and-conditions.pdf"
              rel="noopener noreferrer"
              target="_blank"
            >
              Terms and Conditions
            </a>
            <a
              href="pdf/privacy-policy.pdf"
              rel="noopener noreferrer"
              target="_blank"
            >
              Privacy Policy
            </a>
          </div>
          {/* <p className="copyright">&copy; 2019 Shopee All rights reserved.</p> */}
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
